/* eslint-disable dot-location*/
/* eslint-disable no-useless-escape*/
/* eslint-disable array-callback-return*/
/* eslint-disable react-hooks/exhaustive-deps*/

import 'bootstrap/dist/css/bootstrap.min.css';
import * as HERBUI from "react-bootstrap";
import { HRMS_UI_URL } from '../Api/APIURLS';
const BudgetDataEntryAlert = (props) => {

    return (
        <>
            <div>
                <HERBUI.Modal show={props.show}
                    size="lg" aria-labelledby="contained-modal-title-vcenter"
                    centered
                    scrollable={true}
                >
                    <HERBUI.Modal.Header className="modal-header"  >
                        <HERBUI.Modal.Title style={{ fontSize: '18px' }}>Notification
                        </HERBUI.Modal.Title>
                    </HERBUI.Modal.Header>
                    <HERBUI.Modal.Body
                        className="modal-body">
                        <HERBUI.Container>

                            {/* <HERBUI.Row style={{ margin: '0', padding: '5px' }} className="alert alert-danger">
                                <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-1">
                                    <strong style={{ color: 'maroon' }}>Note: </strong>  All the Secretariat Departments and HoDs are informed that provision for uploading Budget Estimates for 2025-26 will be freezed by 12.00 Noon tomorrow, Hence, all are requested to complete the process by tomorrow 12.00 Noon...<br />
                                    Thank You All...
                                </HERBUI.Col>
                            </HERBUI.Row > 
                            {/* &nbsp;&nbsp; */}

                            {(props.isDdo === "1" || props.isDdo === 1) &&
                                <>
                                    {/* <HERBUI.Row style={{ margin: '0', padding: '5px' }} className="alert alert-danger">
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-1">
                                            <strong style={{ color: 'green' }}>Note for Regular Salary Submitting DDO's :Mandatory Pre Paybill Activities. </strong>
                                            <ol><b>The details indicated in the following four applications should be completed by all concerned before payroll processing for February 2025,
                                                without completing, DDOs cannot generate the pay bill for the month of February 2025 payable in the month of March 2025. All DDOs are requested to
                                                kindly take note of the same and do the necessary. </b>
                                                <li className='mb-2'>
                                                    Employee Earned Leave opening Balances as on 01.01.2025.<br />Tile Name: EL Opening Balance</li>
                                                <li className='mb-2'
                                                >  Advance increments for possessing higher educational qualification and family planning incentive.<br />Tile Name: Family Planning & Higher Education Incentives Details </li>
                                                <li className='mb-2'>
                                                    Confirmation of employee’s ex-Servicemen details.<br />Tile Name: Family Planning & Higher Education Incentives Details </li>
                                                <li className='mb-2'>
                                                    Confirmation of Employee belongs to SC Community? if SC,then Enter Subcaste Details </li>
                                                <li className='mb-2'>
                                                    Confirmation of Employee Regular GPF Balances(AG)</li>

                                            </ol>
                                        </HERBUI.Col>
                                    </HERBUI.Row> */}
                                    <HERBUI.Row style={{ margin: '0', padding: '5px' }} className="alert alert-danger">
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-1">
                                            <strong>
                                                Note:<br />
                                                <b style={{ color: 'green' }}>Dear DDOs,</b><br/></strong>
                                                 It is requested to complete mapping of Reporting Officer for every employee in their respective offices in NIDHI PORTAL.
                                            <ol>
                                                
                                               
                                                <li>
                                                    Navigate to “Master Data” tab and select "Reporting Authority Mapping (iGOT)" tile to submit the details. 
                                                    <a href={HRMS_UI_URL + "/mapReportingOfficer"}> Click Here</a>  </li>
                                                <li>
                                                    As this is being monitored at the highest level, it is requested to complete the task without fail.  </li>

                                            </ol>
                                        </HERBUI.Col>
                                    </HERBUI.Row>
                                </>
                            }
                        </HERBUI.Container>
                    </HERBUI.Modal.Body>
                    <HERBUI.Modal.Footer className="modal-footer">
                        <HERBUI.Button className="btnClose btn-sm btn-secondary" onClick={props.closeModal} >Close</HERBUI.Button>
                    </HERBUI.Modal.Footer>
                </HERBUI.Modal>
            </div>
        </>
    );

}
export default BudgetDataEntryAlert;